module.exports = __webpack_public_path__ + "img/chofu_model_off.e5f8d13d.svg";